import React, { useEffect, useState } from "react";
import "../../css/client/clientDashboard.css";

const ClientDashboard = () => {
  const [clientName, setClientName] = useState("Client name");
  const [fileNo, setFileNo] = useState("file no");
  const [panNo, setPanNo] = useState("pan no");
  const [tanNo, setTanNo] = useState("tan no");
  const [contactPerson, setContactPerson] = useState("contact person");
  const [contactPerson2, setContactPerson2] = useState("contact person 2");
  const [mobile1, setMobile1] = useState("mobile 1");
  const [mobile2, setMobile2] = useState("mobile 2");
  const [email, setEmail] = useState("email");
  const [address1, setAddress1] = useState("address 1");
  const [address2, setAddress2] = useState("address 2");
  const [city, setCity] = useState("city");
  const [state, setState] = useState("state");
  const [pin, setPin] = useState("pin");
  const [ddoName, setDdoName] = useState("ddo name");
  const [ddoPan, setDdoPan] = useState("ddo pan");
  const [ddoDob, setDdoDob] = useState("ddo dob");
  const [authPerson, setAuthPerson] = useState("auth person");
  const [gstNo, setGstNo] = useState("gst Number");
  const [accountantMobile, setAccountantMobile] = useState("account Mobile");
  let clientInfo = JSON.parse(localStorage.getItem("clientInfo"));

  useEffect(() => {
    const client = clientInfo.client;
    setClientName(client?.cn);
    setFileNo(client?.fn);
    setPanNo(client?.pa);
    setTanNo(client?.ta);
    setContactPerson(client?.cp);
    setContactPerson2(client?.cp2);
    setMobile1(client?.m1);
    setMobile2(client?.m2);
    setAddress1(client?.a1);
    setAddress2(client?.a2);
    setCity(client?.ci);
    setState(client?.st);
    setPin(client?.pi);
    setDdoName(client?.dn);
    setDdoPan(client?.dp);
    setDdoDob(client?.ddb);
    setAuthPerson(client?.ap);
    setGstNo(client?.gn);
    setAccountantMobile(client?.am);
    setEmail(client?.ge);
  }, []);

  return (
    <div className="dashboard-container">
      <h1 className="client-name">{clientName || "Client Name"}</h1>

      <div className="dashboard-group bordered-group">
        <div className="field">
          <label>File No:</label>
          <span>{fileNo}</span>
        </div>
        <div className="field">
          <label>PAN No:</label>
          <span>{panNo}</span>
        </div>
        <div className="field">
          <label>TAN No:</label>
          <span>{tanNo}</span>
        </div>
      </div>

      <div className="dashboard-group bordered-group">
        <div className="field">
          <label>Contact Person 1:</label>
          <span>{contactPerson}</span>
        </div>
        <div className="field">
          <label>Mobile 1:</label>
          <span>{mobile1}</span>
        </div>
        <div className="field">
          <label>Contact Person 2:</label>
          <span>{contactPerson}</span>
        </div>
        <div className="field">
          <label>Mobile 2:</label>
          <span>{mobile2}</span>
        </div>
        <div className="field">
          <label>Email:</label>
          <span>{email}</span>
        </div>
        <div className="field">
          <label>Address Line 1:</label>
          <span>{address1}</span>
        </div>
        <div className="field">
          <label>Address Line 2:</label>
          <span>{address2}</span>
        </div>
        <div className="field">
          <label>City:</label>
          <span>{city}</span>
        </div>
        <div className="field">
          <label>State:</label>
          <span>{state}</span>
        </div>
        <div className="field">
          <label>Pin Code:</label>
          <span>{pin}</span>
        </div>
      </div>

      <div className="dashboard-group bordered-group">
        <div className="field">
          <label>DDO Name:</label>
          <span>{ddoName}</span>
        </div>
        <div className="field">
          <label>DDO PAN:</label>
          <span>{ddoPan}</span>
        </div>
        <div className="field">
          <label>DDO DOB:</label>
          <span>{ddoDob}</span>
        </div>
        <div className="field">
          <label>GST No:</label>
          <span>{gstNo}</span>
        </div>
        <div className="field">
          <label>Authorized Person & Father Name:</label>
          <span>{authPerson}</span>
        </div>
        <div className="field">
          <label>Accountant Mobile:</label>
          <span>{accountantMobile}</span>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboard;
